import { render } from "./Customer2.vue?vue&type=template&id=f81b5854"
import script from "./Customer2.vue?vue&type=script&lang=js"
export * from "./Customer2.vue?vue&type=script&lang=js"

import "./Customer2.vue?vue&type=style&index=0&id=f81b5854&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__